module.exports = __webpack_public_path__ + "static/media/icon_call_history_video.aecd2cc5.svg";